import { AccesoTriviaMenu } from '@/features/comunidad'
import { SidebarSection } from './SidebarSection'
import { navigation } from './navigation'

export function SidebarNav() {
  return (
    <nav className="flex-1 overflow-y-auto pb-3">
      {navigation.map((section) => (
        <SidebarSection key={section.id} section={section} />
      ))}
      {/* El acceso a la trivia va FUERA de `navigation` (goal trivias 5): esas
          entradas son rutas internas del portal y esta sale a comunidad-web en
          una pestaña nueva. Sin `VITE_COMUNIDAD_URL` no pinta nada. */}
      <AccesoTriviaMenu />
    </nav>
  )
}
